import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { CollapsibleSection } from "./CollapsibleSection";
import { CustomLink } from "./CustomLink";
import { FiLifeBuoy } from "@react-icons/all-files/fi/FiLifeBuoy";
import { useButtonColor } from "../utils";

type TroubleshootingSectionProps = {
  children: React.ReactNode;
  title?: string;
  courseTitle?: string;
  lessonTitle?: string;
};

export function TroubleshootingSection({
  children,
  title,
  courseTitle,
  lessonTitle,
}: TroubleshootingSectionProps) {
  const indigo = useButtonColor("indigo");
  return (
    <CollapsibleSection
      type="warning"
      title={title || "Did something go wrong?"}
    >
      {children}
      {"\n"}
      <Flex>
        <Box py="1" pr="2">
          <FiLifeBuoy />
        </Box>
        <Text>
          Still having trouble? Visit the{" "}
          <CustomLink
            href="https://community.apollographql.com/tags/c/other/22/odyssey"
            color="link"
            onClick={() =>
              window.gtag?.("event", "forums_troubleshooting_link_click", {
                courseTitle,
                lessonTitle,
              })
            }
          >
            Odyssey forums
          </CustomLink>{" "}
          to get help.
        </Text>
      </Flex>
    </CollapsibleSection>
  );
}
